import { useEffect, useState } from "react";
import apiRequest from "../../../utils/apiClient";
import { subscriptionStatusUrl } from "../../constants";
import { SubscriptionStatusResponse } from "../../../types/user";
import { SUBSCRIPTION_TAB } from "../constants/accountText";

interface UseSubscriptionStatusResult {
  plan: string;
  loadError: boolean;
}

export const useSubscriptionStatus = (): UseSubscriptionStatusResult => {
  const [plan, setPlan] = useState<string>(SUBSCRIPTION_TAB.FALLBACK_PLAN);
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    setLoadError(false);
    apiRequest(subscriptionStatusUrl, { method: "POST" })
      .then(async (response) => {
        if (response.status === 404) {
          setPlan(SUBSCRIPTION_TAB.FALLBACK_PLAN);
          return;
        }
        if (!response.ok) {
          setLoadError(true);
          return;
        }
        const data: SubscriptionStatusResponse = await response.json();
        setPlan(data.subscription?.plan || SUBSCRIPTION_TAB.FALLBACK_PLAN);
      })
      .catch(() => setLoadError(true));
  }, []);

  return { plan, loadError };
};
